import { rewardStatus } from 'json/mall-options'
export let oldToNewTabs = [
  {
    label: '全部脐荐康用户',
    value: 'ALL'
  },
  {
    label: '老用户',
    value: 'OLD'
  },
  {
    label: '新用户',
    value: 'NEW'
  }
]
export let filterLabels = [
//   {
//     label: '老用户绑定状态',
//     type: 'select',
//     value: 'oldBind',
//     clearable: true,
//     options: [
//       {
//         label: '是',
//         value: 'true'
//       },
//       {
//         label: '否',
//         value: 'false'
//       }
//     ]
//   },
  {
    label: '老用户首次奖励状态',
    type: 'select',
    value: 'oldFirstRewardStatus',
    clearable: true,
    options: rewardStatus
  },
  {
    label: '老用户后继奖励状态',
    type: 'select',
    value: 'oldSecondRewardStatus',
    clearable: true,
    options: rewardStatus
  },
  {
    label: '新用户奖励状态',
    type: 'select',
    value: 'newRewardStatus',
    clearable: true,
    options: rewardStatus
  },
  {
    label: '达标时间',
    type: 'time-slot',
    startName: 'achieveDateStart', // 返回数据时，开始时间的字段名
    endName: 'achieveDateEnd', // 返回数据时，结束时间的字段名
    value: 'achieveDate'
  }
]
// 老带新表格表头数据
export let oldToNewTableLabels = [
//   {
//     label: '序号',
//     value: ''
//   },
//   {
//     label: '达标时间',
//     value: 'achieve_date'
//   },
//   {
// label: '邀请人(老用户)',
// labels: [
//   {
//     label: '生命银行用户',
//     value: 'oldCustomer.userName'
//   },
//   {
//     label: 'C端手机号',
//     value: 'oldCustomer.userMobile'
//   },
//   {
//     label: 'CPS合同',
//     value: 'oldCustomer.cpsContractCode'
//   },
//   {
//     label: '返券',
//     value: 'oldCustomer.couponRewardAmount'
//   },
//   {
//     label: '返现',
//     value: 'oldCustomer.moneyRewardAmount'
//   },
//   {
//     label: '发放状态',
//     value: 'oldCustomer.reward_status'
//   },
//   {
//     label: '发放时间',
//     value: 'oldCustomer.reward_date'
//   }
// ]
//   },
//   {
//     label: '被邀请人(新用户)',
//     labels: [
//       {
//         label: '生命银行用户',
//         value: 'newCustomer.userName'
//       },
//       {
//         label: 'C端手机号',
//         value: 'newCustomer.userMobile'
//       },
//       {
//         label: 'CPS合同',
//         value: 'newCustomer.cpsContractCode'
//       },
//       {
//         label: '返券',
//         value: 'newCustomer.couponRewardAmount'
//       },
//       {
//         label: '返现',
//         value: 'newCustomer.moneyRewardAmount'
//       },
//       {
//         label: '发放状态',
//         value: 'newCustomer.reward_status'
//       },
//       {
//         label: '发放时间',
//         value: 'newCustomer.reward_date'
//       }
//     ]
//   }
]
// 老用户表头
export let oldTableLabels = [
  // {
  //   label: '生命银行用户',
  //   value: 'oldCustomer.userName'
  // },
  // {
  //   label: 'C端手机号',
  //   value: 'oldCustomer.userMobile'
  // },
  // {
  //   label: '达标时间',
  //   value: 'achieve_date'
  // },
  // {
  //   label: '绑定合同时间',
  //   value: 'oldCustomer.CPSbindDate'
  // },
  // {
  //   label: 'CPS合同',
  //   value: 'oldCustomer.cpsContractCode'
  // },
  // {
  //   label: '地区',
  //   value: 'oldCustomer.cpsRegion'
  // },
  // {
  //   label: '返现',
  //   value: 'oldCustomer.moneyRewardAmount'
  // },
  // {
  //   label: '返券',
  //   value: 'oldCustomer.couponRewardAmount'
  // }
//   {
//     label: '发放状态',
//     value: 'oldCustomer.reward_status'
//   },
//   {
//     label: '发放时间',
//     value: 'oldCustomer.reward_date'
//   }
]
// 新用户表头
export let newTableLabels = [
  // {
  //   label: '生命银行用户',
  //   value: 'newCustomer.userName'
  // },
  // {
  //   label: 'C端手机号',
  //   value: 'newCustomer.userMobile'
  // },
  // {
  //   label: '达标时间',
  //   value: 'newCustomer.reward_date'
  // },
  // {
  //   label: '绑定合同时间',
  //   value: 'newCustomer.CPSbindDate'
  // },
  // {
  //   label: 'CPS合同',
  //   value: 'newCustomer.cpsContractCode'
  // },
  // {
  //   label: '地区',
  //   value: 'newCustomer.cpsRegion'
  // },
  // {
  //   label: '返现',
  //   value: 'newCustomer.moneyRewardAmount'
  // },
  // {
  //   label: '返券',
  //   value: 'newCustomer.couponRewardAmount'
  // }
//   {
//     label: '发放状态',
//     value: 'newCustomer.reward_status'
//   },
//   {
//     label: '发放时间',
//     value: 'newCustomer.reward_date'
//   }
]
// 老用户筛选条件
export let oldFilterLabels = [
  {
    label: '首次奖励状态',
    type: 'select',
    value: 'oldFirstRewardStatus',
    clearable: true,
    options: rewardStatus
  },
  {
    label: '后继奖励状态',
    type: 'select',
    value: 'oldSecondRewardStatus',
    clearable: true,
    options: rewardStatus
  },
  {
    label: '达标时间',
    type: 'time-slot',
    startName: 'applyStartTime', // 返回数据时，开始时间的字段名
    endName: 'applyEndTime', // 返回数据时，结束时间的字段名
    value: 'createdtime'
  }
]
// 新用户筛选条件
export let newFilterLabels = [
  {
    label: '发放状态',
    type: 'select',
    value: 'newRewardStatus',
    clearable: true,
    options: rewardStatus
  },
  {
    label: '达标时间',
    type: 'time-slot',
    startName: 'applyStartTime', // 返回数据时，开始时间的字段名
    endName: 'applyEndTime', // 返回数据时，结束时间的字段名
    value: 'createdtime'
  }
]
